import { render, staticRenderFns } from "./add-goods-pop.vue?vue&type=template&id=0178f601&scoped=true&"
import script from "./add-goods-pop.vue?vue&type=script&lang=js&"
export * from "./add-goods-pop.vue?vue&type=script&lang=js&"
import style0 from "./add-goods-pop.vue?vue&type=style&index=0&id=0178f601&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0178f601",
  null
  
)

export default component.exports